//dev
// const superStudent = 'http://103.41.205.87:80/api/v1/application/';

// prod
const superStudent = 'https://development.niecindonesia.com/api/v1/application/';
const masterKey = 'koibg3kyOxX73kKTNwCsbNXnocy6nMPQ';

const API_URL = {
    superStudent,
    masterKey
}

export default API_URL;
